export default __webpack_public_path__ + "static/media/waiting-gif.20985091.gif";